<template>
  <ul class="base-autocomplete"
      ref="box"
      cy="autocomplete-box">
    <template v-for="(item, idx) in list">
      <li @mousedown="select($event, item)"
          :class="{ highlight: index === idx }"
          :key="idx">
        <span class="ac-row">
          <span class="ac-label">{{ getLabel(item) }}</span>
          <span v-if="item && item.gestiune && activeField === 'denumire'" class="ac-stock-qty"> <span class="ac-stock-num">{{ item.stoc }}</span>
            {{ item.um || 'buc' }}
          </span>
        </span>
      </li>
    </template>
  </ul>
</template>

<script>
  export default {
    name: 'Autocomplete',
    props: {
      name: {
        type: String,
        required: true,
        default: ''
      },
      list: {
        type: Array,
        required: true,
        default: () => []
      },
      positionY: {
        type: Number,
        required: true,
        default: 0
      },
      positionX: {
        type: Number,
        required: true,
        default: 0
      },
      activeField: {
        type: String,
        default: 'denumire'
      }
    },
    data () {
      return {
        selected: undefined,
        index: -1
      }
    },
    mounted () {
      this.$refs.box.style.top = `${this.positionY}px`
      this.$refs.box.style.left = `${this.positionX}px`
      window.addEventListener('keydown', this.listenKeys)
    },
    methods: {
      listenKeys (ev) {
        switch (ev.key) {
          case 'ArrowDown':
            this.index < this.list.length - 1 && (this.index += 1)
            break
          case 'ArrowUp':
            this.index > 0 && (this.index -= 1)
            break
          case 'Enter':
            if (this.index < 0) return
            ev.preventDefault()
            this.select(undefined, this.list[this.index])
            break
          case 'Escape':
            this.$emit('hide')
            break
          default:
            // console.log(ev.key)
        }
      },
      select (ev, value) {
        ev && ev.stopPropagation()
        this.$emit('select-item', {
          name: this.name,
          value
        })
      },
      getLabel (item) {
        if (item == null) return ''
        if (typeof item === 'string') return item
        return item[this.activeField] ?? ''
      }
    },
    watch: {
      positionY: function (newVal) {
        this.$refs.box.style.top = `${newVal}px`
      },
      positionX: function (newVal) {
        this.$refs.box.style.left = `${newVal}px`
      }
    },
    destroyed () {
      window.removeEventListener('keydown', this.listenKeys)
    }
  }
</script>

<style lang="less">
  .base-autocomplete {
    @media only screen and (min-width: 0) {
      width: 200px;
      max-height: 300px;
      overflow-y: scroll;
      overflow-x: hidden;
      position: absolute;
      top: 100px;
      font-size: 1.6rem;
      background-color: white;
      z-index: 9;
      box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.2);

      li {
        padding: 8px;
        cursor: default;
        &:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }
      }

      .highlight {
        background-color: rgba(0, 0, 0, 0.05);
      }

      .ac-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
      }

      // Nume lung → trunchiat cu „…", fără scroll orizontal. min-width:0 permite
      // shrink-ul în flex; qty-ul din dreapta rămâne vizibil (flex-shrink:0).
      .ac-label {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .ac-stock-qty {
        flex-shrink: 0;
        font-size: 1.6rem;
        font-weight: 400;
        color: #000;
        white-space: nowrap;

        .ac-stock-num {
          font-weight: 600;
          color: #000;
        }
      }
    }

    @media only screen and (min-width: 1024px) {
      width: 300px;
    }

  }
</style>
